import axios, {AxiosResponse} from 'axios'
const api = '/api/'

const kankorTermList = async ({params}) => {
  const response = await axios.get(`${api}kankor-term/list`, params)
  return response.data
}

const kankorTermCreate = async ({data}) => {
  await axios.post(`${api}kankor-term/store`, data)
}

const kankorTermEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}kankor-term/edit/${id}`)
  return response.data
}

const kankorTermDelete = async (id: string) => {
  await axios.get(`${api}kankor-term/destroy/${id}`)
}

const kankorTermView = async (id: string) => {
  const response = await axios.get(`${api}kankor-term/view/${id}`)
  return response.data
}

const kankorRoomList = async (id: string) => {
  const response = await axios.get(`${api}kankor-room/list/${id}`)
  return response.data
}

const kankorRoomCreate = async ({data}) => {
  await axios.post(`${api}kankor-room/store`, data)
}

const kankorRoomEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}kankor-room/edit/${id}`)
  return response.data
}

const kankorRoomDelete = async (id: string) => {
  await axios.get(`${api}kankor-room/destroy/${id}`)
}

const kankorApplicationCreate = async ({data}) => {
  await axios.post(`${api}application/store`, data)
}

const uploadPhoto = async ({data}) => {
  await axios.post(`${api}application/upload-photo`, data)
}

const kankorApplicationEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}application/edit/${id}`)
  return response.data
}

const kankorApplicationView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}application/view/${id}`)
  return response.data
}

const kankorApplicationDelete = async (id: string) => {
  await axios.get(`${api}application/destroy/${id}`)
}

const getTermAndProgram = async () => {
  const response = await axios.get(`${api}application/term-and-program`)
  return response.data
}

const applicationStudents = async (id: string) => {
  const response = await axios.get(`${api}kankor-room/app-students/${id}`)
  return response.data
}

const sendStdToRoom = async ({data}) => {
  const response = await axios.post(`${api}kankor-room/send-std-to-room`, data)
  return response.data
}

const roomStudents = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}kankor-room/view/${id}`)
  return response.data
}

const removeStdFromRoom = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}kankor-room/remove-std-from-room/${id}`)
  return response.data
}

const printCard = async (type: string, id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}kankor-room/print-card/${type}/${id}`)
  return response.data
}

const appAttendance = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}application/attendance/${id}`)
  return response.data
}

const getAppScore = async (id: string) => {
  const response = await axios.get(`${api}kankor-term/get-app-score/${id}`)
  return response.data
}

const appScoreStore = async ({data}) => {
  const response = await axios.post(`${api}kankor-term/app-score-store`, data)
  return response.data
}

const approveApplicationScore = async (id: string) => {
  const response = await axios.get(`${api}kankor-term/approve-application-score/${id}`)
  return response.data
}

const bachelorAppExcelBook = async (id: string) => {
  const response = await axios.get(`${api}kankor-term/bach-excel-book/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Bachelor Book.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
}

const masterAppExcelBook = async (id: string) => {
  const response = await axios.get(`${api}kankor-term/master-excel-book/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Master Book.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()

  return {success: true}
}

const getPrograms = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}application/get-programs/${id}`)
  return response.data
}

const getlistKankorApplicants = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}application/get-kankor-succeeded-applicants-list/${id}`)
  return response.data
}

const getKankorRooms = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}kankor-room/get-rooms/${id}`)
  return response.data
}

const changeAppRoom = async ({data}) => {
  const response = await axios.post(`${api}kankor-room/change-rooom`, data)
  return response.data
}

const getTerms = async () => {
  const response = await axios.get(`${api}kankor-report/get-terms`)
  return response.data
}

const termReport = async (id: any) => {
  const response = await axios.get(`${api}kankor-report/term-report/${id}`)
  return response.data
}

const termReportPrint = async (id: any) => {
  const response = await axios.get(`${api}kankor-report/term-report-print/${id}`)
  return response.data
}

const termReportExcel = async (id: string) => {
  const response = await axios.get(`${api}kankor-report/term-report-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Term Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()

  return {success: true}
}

const termSuccessReport = async (id: any) => {
  const response = await axios.get(`${api}kankor-report/term-success-report/${id}`)
  return response.data
}

const termSuccessReportPrint = async (id: any) => {
  const response = await axios.get(`${api}kankor-report/term-success-report-print/${id}`)
  return response.data
}

const termSuccessReportExcel = async (id: string) => {
  const response = await axios.get(`${api}kankor-report/term-success-report-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Succeed Term Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()

  return {success: true}
}

const kankorService = {
  termSuccessReport,
  termSuccessReportPrint,
  termSuccessReportExcel,
  termReportExcel,
  termReportPrint,
  termReport,
  getTerms,
  changeAppRoom,
  getKankorRooms,
  getPrograms,
  bachelorAppExcelBook,
  masterAppExcelBook,
  kankorApplicationView,
  approveApplicationScore,
  appScoreStore,
  getAppScore,
  appAttendance,
  printCard,
  removeStdFromRoom,
  roomStudents,
  sendStdToRoom,
  applicationStudents,
  getTermAndProgram,
  uploadPhoto,
  kankorRoomList,
  kankorRoomCreate,
  kankorRoomEdit,
  kankorRoomDelete,
  kankorApplicationCreate,
  kankorApplicationEdit,
  kankorApplicationDelete,
  kankorTermList,
  kankorTermCreate,
  kankorTermEdit,
  kankorTermDelete,
  kankorTermView,
  getlistKankorApplicants,
}

export default kankorService
